/** QuickPlan — Champ de paramètre de composant : liste si `options`, sinon numérique libre. */
import NumField from './NumField.jsx';

export default function ParamField({ param, value, onChange }) {
  const label = `${param.label ?? param.key}${param.unit ? ` (${param.unit})` : ''}`;
  const hint = [param.min != null && `min ${param.min}`, param.max != null && `max ${param.max}`].filter(Boolean).join(' · ');
  return (
    <label title={hint || undefined}>
      {label}
      {param.options
        ? (
          <select value={value} onChange={(e) => onChange(Number(e.target.value))}>
            {(param.options.includes(value) ? param.options : [...param.options, value].sort((a, b) => a - b)).map((o) => <option key={o} value={o}>{o}</option>)}
          </select>
        )
        : <NumField value={value} onCommit={(v) => v != null && onChange(v)} />}
    </label>
  );
}
